// ─── PACK DEFINITIONS ───────────────────────────────────────────
//
// Phase A migration (2026-05-09) :
// - 3 nouveaux packs actifs : consultation_initiale_220, suivi_3m_990, suivi_6m_1990
// - 6 anciens packs marques `archived: true` : conserves pour les clientes en cours,
//   mais filtres dans le dropdown de creation nouvelle cliente.
//
// V3.1 modele tarifaire (2026-05-13) :
// - Les 3 packs sont d'ACCOMPAGNEMENT PUR (RDV, app, suivi)
// - Credit analyse inclus par pack :
//     consultation_initiale_220 = 0 CHF
//     suivi_3m_990              = 250 CHF (1 analyse ciblee)
//     suivi_6m_1990             = 400 CHF (1 analyse approfondie)
// - Facturation : Anissa avance les frais labo (Ortho-Analytic) puis
//   refacture la cliente apres reception des resultats. La cliente paye
//   tout a Anissa Nutrition, jamais directement au labo.
// - Anissa propose les analyses uniquement sur pertinence clinique
// - Pas de notion de "marge sur pack" — les packs sont du temps humain

export const PACK_DEFINITIONS = {

  // ─── NOUVEAUX PACKS (V2 — Direction E, 2026-05-09) ─────────────

  consultation_initiale_220: {
    appMode: 'oneshot',
    label: 'Consultation initiale - anamnèse',
    price: 220,
    durationWeeks: 0,
    initialAnamnesisConsultations: 1,
    includedFollowupConsultations: 0,
    consultations: 1,
    steps: [],
    archived: false,
    // V97.12.1 — Credit analyse inclus dans l'accompagnement (CHF).
    // 0 = aucune analyse incluse, 250 = ciblee, 400 = approfondie.
    includedAnalysisCreditChf: 0,
  },
  suivi_3m_990: {
    appMode: 'followup',
    label: 'Suivi 3 mois',
    price: 990,
    durationWeeks: 12,
    initialAnamnesisConsultations: 1,
    includedFollowupConsultations: 2,
    consultations: 3,
    archived: false,
    includedAnalysisCreditChf: 250,
    steps: [
      { weekOffset: 4,  type: 'review',       label: 'Point de suivi S4',              template: null },
      { weekOffset: 6,  type: 'consultation', label: 'Rendez-vous de mi-parcours',     template: null },
      { weekOffset: 12, type: 'review',       label: 'Bilan de fin de suivi',           template: null },
      { weekOffset: 12, type: 'consultation', label: 'Rendez-vous final',               template: null },
    ],
  },
  suivi_6m_1990: {
    appMode: 'followup',
    label: 'Suivi 6 mois',
    price: 1990,
    durationWeeks: 24,
    initialAnamnesisConsultations: 1,
    includedFollowupConsultations: 4,
    consultations: 5,
    archived: false,
    includedAnalysisCreditChf: 400,
    steps: [
      { weekOffset: 4,  type: 'review',       label: 'Point de suivi S4',              template: null },
      { weekOffset: 6,  type: 'consultation', label: 'Rendez-vous de suivi 1',          template: null },
      { weekOffset: 8,  type: 'review',       label: 'Point de suivi S8',              template: null },
      { weekOffset: 12, type: 'consultation', label: 'Consultation de suivi',          template: null },
      { weekOffset: 16, type: 'review',       label: 'Point de suivi S16',             template: null },
      { weekOffset: 18, type: 'consultation', label: 'Rendez-vous de suivi 3',          template: null },
      { weekOffset: 24, type: 'review',       label: 'Bilan de fin de suivi',           template: null },
      { weekOffset: 24, type: 'consultation', label: 'Rendez-vous final',               template: null },
    ],
  },

  // ─── ANCIENS PACKS ARCHIVES (clientes en cours uniquement) ─────

  oneshot_180: {
    appMode: 'oneshot',
    label: 'Bilan Nutritionnel',
    price: 180,
    durationWeeks: 0,
    consultations: 1,
    steps: [],
    archived: true,
  },
  oneshot_280: {
    appMode: 'oneshot',
    label: 'Bilan Sanguin',
    price: 280,
    durationWeeks: 0,
    consultations: 1,
    steps: [],
    archived: true,
  },
  oneshot_750: {
    appMode: 'oneshot',
    label: 'Nutrition ADN',
    price: 750,
    durationWeeks: 0,
    consultations: 1,
    steps: [],
    archived: true,
  },
  suivi_3m: {
    appMode: 'followup',
    label: 'Suivi Essentiel 3 mois',
    price: 490,
    durationWeeks: 12,
    consultations: 2,
    archived: true,
    steps: [
      { weekOffset: 4,  type: 'review',       label: 'Bilan S4 — Adhérence',         template: 'adherence' },
      { weekOffset: 8,  type: 'consultation',  label: 'Consultation mi-parcours',      template: null },
      { weekOffset: 12, type: 'review',        label: 'Bilan final',                   template: 'final' },
    ],
  },
  suivi_6m: {
    appMode: 'followup',
    label: 'Suivi Complet 6 mois',
    price: 850,
    durationWeeks: 24,
    consultations: 4,
    archived: true,
    steps: [
      { weekOffset: 4,  type: 'review',       label: 'Bilan S4 — Adhérence',         template: 'adherence' },
      { weekOffset: 8,  type: 'review',       label: 'Bilan S8 — Résultats',         template: 'results' },
      { weekOffset: 12, type: 'consultation', label: 'Consultation mi-parcours',      template: null },
      { weekOffset: 16, type: 'review',       label: 'Bilan S16 — Métabolique',      template: 'metabolic' },
      { weekOffset: 24, type: 'review',       label: 'Bilan final',                  template: 'final' },
    ],
  },
  suivi_adn: {
    appMode: 'followup',
    label: 'Suivi ADN & Longévité',
    price: 1490,
    durationWeeks: 24,
    consultations: 6,
    archived: true,
    steps: [
      { weekOffset: 2,  type: 'bloodwork',   label: 'Bilan sanguin MGD',            template: null },
      { weekOffset: 4,  type: 'review',      label: 'Bilan S4 — Adhérence',         template: 'adherence' },
      { weekOffset: 6,  type: 'dna',         label: 'Résultats ADN à saisir',       template: null },
      { weekOffset: 8,  type: 'review',      label: 'Bilan S8 — Résultats',         template: 'results' },
      { weekOffset: 12, type: 'consultation',label: 'Consultation ADN + plan',      template: null },
      { weekOffset: 16, type: 'review',      label: 'Bilan S16 — Métabolique',      template: 'metabolic' },
      { weekOffset: 20, type: 'consultation',label: 'Consultation optimisation',    template: null },
      { weekOffset: 24, type: 'review',      label: 'Bilan final longévité',        template: 'final' },
    ],
  },
};

// ─── HELPERS PACKS ──────────────────────────────────────────────

const CLOSED_PACK_ACCESS = Object.freeze({
  known: false,
  appMode: null,
  continuousFollowup: false,
  hasScheduledSteps: false,
  initialAnamnesisConsultations: 0,
  includedFollowupConsultations: 0,
  totalAppointments: 0,
});

/**
 * Source unique des droits structurels d'un pack.
 *
 * Un pack inconnu n'ouvre jamais le suivi continu par défaut. Ce helper ne
 * porte aucune règle clinique : il décrit seulement le contrat administratif
 * choisi par Anissa lors de la création de la fiche.
 */
export function getPackAccess(packType) {
  if (typeof packType !== 'string' || !packType) return CLOSED_PACK_ACCESS;
  const pack = PACK_DEFINITIONS[packType];
  if (!pack || (pack.appMode !== 'oneshot' && pack.appMode !== 'followup')) {
    return CLOSED_PACK_ACCESS;
  }
  const continuousFollowup = pack.appMode === 'followup';
  const initialAnamnesisConsultations = Number.isInteger(pack.initialAnamnesisConsultations)
    ? Math.max(0, pack.initialAnamnesisConsultations)
    : 0;
  const includedFollowupConsultations = Number.isInteger(pack.includedFollowupConsultations)
    ? Math.max(0, pack.includedFollowupConsultations)
    : (continuousFollowup || pack.archived === true) && Number.isInteger(pack.consultations)
      ? Math.max(0, pack.consultations)
      : 0;
  return {
    known: true,
    appMode: pack.appMode,
    continuousFollowup,
    hasScheduledSteps: continuousFollowup && Array.isArray(pack.steps) && pack.steps.length > 0,
    initialAnamnesisConsultations,
    includedFollowupConsultations,
    totalAppointments: initialAnamnesisConsultations + includedFollowupConsultations,
  };
}

export function isContinuousFollowupPack(packType) {
  return getPackAccess(packType).continuousFollowup;
}

/**
 * Retourne uniquement les packs actifs pour la creation d'une nouvelle fiche.
 * Les packs archives restent lisibles pour les clientes existantes.
 */
export function getActivePacks() {
  return Object.entries(PACK_DEFINITIONS)
    .filter(([, pack]) => !pack.archived)
    .map(([key, pack]) => ({ key, ...pack }));
}

/**
 * Retourne tous les packs (actifs + archives), utile pour l'affichage
 * des fiches clientes en cours.
 */
export function getAllPacks() {
  return Object.entries(PACK_DEFINITIONS)
    .map(([key, pack]) => ({ key, ...pack }));
}

/**
 * Indique si un pack donne est archive (ancien pack legacy).
 * Utile pour afficher un badge "Pack legacy" sur les fiches clientes en cours.
 */
export function isPackArchived(packType) {
  return PACK_DEFINITIONS[packType]?.archived === true;
}

// ─── TEMPLATE QUESTIONS PAR ÉTAPE ───────────────────────────────

export const REVIEW_TEMPLATES = {
  adherence: {
    label: 'Bilan d\'adhérence',
    description: 'Évaluation de l\'adhérence au plan et du ressenti général',
    fields: ['adherence', 'energy', 'digestion', 'difficulty', 'organisation', 'main_issue'],
  },
  results: {
    label: 'Bilan résultats',
    description: 'Évaluation des résultats visibles et des blocages rencontrés',
    fields: ['adherence', 'progress', 'energy', 'digestion', 'cheats', 'main_issue'],
  },
  metabolic: {
    label: 'Bilan métabolique',
    description: 'Adaptation métabolique et ajustements nécessaires',
    fields: ['adherence', 'progress', 'energy', 'digestion', 'difficulty', 'main_issue'],
  },
  final: {
    label: 'Bilan final',
    description: 'Bilan de clôture du programme',
    fields: ['adherence', 'progress', 'energy', 'digestion', 'cheats', 'difficulty', 'main_issue'],
  },
};

// ─── CALCUL DU PLANNING DE SUIVI ────────────────────────────────

/**
 * Calcule les étapes de suivi pour un client selon son pack.
 * Retourne un tableau d'étapes avec dates calculées et statuts.
 *
 * V96.27 — Le schedule ne demarre QUE si Anissa a marque le programme comme
 * remis (packStartedAtConfirmed === true). Sinon retourne [] et l'UI affiche
 * un etat "En attente remise programme" + bouton de marquage manuel.
 * Compat retro : les clientes deja confirmees auto avant V96.27 conservent
 * leur date d'origine.
 */
export function buildPackFollowupSchedule(client) {
  const packType = client?.packType;
  const pack = PACK_DEFINITIONS[packType];
  const access = getPackAccess(packType);
  if (!pack || !access.hasScheduledSteps) return [];

  // V96.27 : pas de schedule tant que la remise n'est pas confirmee manuellement
  if (!client.packStartedAtConfirmed || !client.packStartedAt) {
    return [];
  }

  const stored = new Date(client.packStartedAt);
  const created = new Date(client.createdAt || Date.now());
  // packStartedAt valide = même jour ou postérieur à createdAt
  const startedAt = stored >= created ? stored : created;

  const packSchedule = client.packSchedule || [];
  const journey = client.journeyState || client.journey_state || {};
  const loggedFollowups = consultationsInPeriod(
    journey.consultations_log,
    client.packStartedAt,
  );
  const consultationStepIndexes = pack.steps
    .map((step, index) => (step.type === 'consultation' ? index : null))
    .filter((index) => index !== null);

  return pack.steps.map((step, idx) => {
    const dueDate = new Date(startedAt);
    dueDate.setDate(dueDate.getDate() + step.weekOffset * 7);

    const existing = packSchedule.find(s => s.stepNumber === idx + 1) || {};
    const consultationIndex = consultationStepIndexes.indexOf(idx);
    const consultationOrdinal = consultationIndex >= 0 ? consultationIndex + 1 : null;
    const loggedConsultation = consultationOrdinal
      ? loggedFollowups[consultationOrdinal - 1]
      : null;
    const now = new Date();
    const status = loggedConsultation
      ? 'done'
      : (existing.status || (dueDate < now ? 'late' : 'pending'));
    const isLate = dueDate < now && status !== 'done';
    const isDueSoon = !isLate && (dueDate - now) / (1000 * 60 * 60 * 24) <= 7;

    return {
      stepNumber: idx + 1,
      weekOffset: step.weekOffset,
      type: step.type,
      label: step.label,
      template: step.template,
      dueDate: dueDate.toISOString(),
      status,
      isLate,
      isDueSoon,
      reviewId: existing.reviewId || null,
      completedAt: existing.completedAt || loggedConsultation?.date || null,
      notifiedAt: existing.notifiedAt || null,
      consultationOrdinal,
    };
  });
}

/**
 * Retourne la prochaine étape à traiter pour un client.
 * Une seule étape active = première non done, triée par weekOffset.
 */
export function getNextPendingStep(client) {
  const steps = buildPackFollowupSchedule(client);
  return steps
    .filter(s => s.status !== 'done')
    .sort((a, b) => a.weekOffset - b.weekOffset)[0] || null;
}

/**
 * Détermine si le bouton "Envoyer bilan" doit s'afficher pour une étape.
 * Conditions : type review, pas déjà envoyée, due dans <= 7 jours ou en retard.
 */
export function canSendPackReview(step) {
  if (!step) return false;
  if (step.type !== 'review') return false;
  if (step.status === 'sent' || step.status === 'done') return false;
  const now = new Date();
  const due = new Date(step.dueDate);
  const daysUntilDue = (due - now) / (1000 * 60 * 60 * 24);
  return daysUntilDue <= 7;
}

/**
 * Retourne le template questionnaire pour une étape donnée.
 */
export function getReviewTemplateForStep(packType, stepNumber) {
  const pack = PACK_DEFINITIONS[packType];
  if (!pack) return null;
  const step = pack.steps[stepNumber - 1];
  if (!step || !step.template) return null;
  return REVIEW_TEMPLATES[step.template] || null;
}

// Contrat unique de création et de relecture d'un bilan. Les nouveaux packs
// administratifs sans thème explicite utilisent le questionnaire réellement
// envoyé par App.jsx ; une valeur inconnue reste fermée.
export function resolveSentPackReviewTemplate(step) {
  const template = step?.template == null ? 'adherence' : step.template;
  return typeof template === 'string' && Object.hasOwn(REVIEW_TEMPLATES, template)
    ? template
    : null;
}

/**
 * Vérifie les étapes dues ou en retard sur tous les clients.
 * Retourne un tableau d'alertes.
 */
export function checkStepsDue(clients) {
  const alerts = [];
  for (const client of clients) {
    const packType = client.packType;
    if (!isContinuousFollowupPack(packType)) continue;

    const steps = buildPackFollowupSchedule(client);
    const prenom = client.prenom || client.form?.prenom || 'Client';

    for (const step of steps) {
      if (step.status === 'done') continue;
      if (step.isLate) {
        alerts.push({
          clientId: client.id,
          clientName: prenom,
          step,
          severity: 'late',
          message: `Étape en retard : ${step.label} — ${prenom}`,
        });
      } else if (step.isDueSoon && step.type === 'review') {
        alerts.push({
          clientId: client.id,
          clientName: prenom,
          step,
          severity: 'due_soon',
          message: `Questionnaire à envoyer cette semaine : ${step.label} — ${prenom}`,
        });
      }
    }
  }
  return alerts;
}

/**
 * Met à jour le statut d'une étape dans packSchedule du client.
 * Retour : le nouveau packSchedule à sauvegarder.
 */
export function updateStepStatus(client, stepNumber, updates) {
  const schedule = [...(client.packSchedule || [])];
  const idx = schedule.findIndex(s => s.stepNumber === stepNumber);
  const updated = {
    stepNumber,
    ...(idx >= 0 ? schedule[idx] : {}),
    ...updates,
  };
  if (idx >= 0) schedule[idx] = updated;
  else schedule.push(updated);
  return schedule;
}

/**
 * Termine le jalon administratif courant uniquement si son type correspond a
 * l'action reellement effectuee. Les jalons precedents doivent deja etre
 * termines : enregistrer une consultation ne peut donc pas sauter un bilan
 * encore en attente.
 */
export function completeCurrentPackStep({
  packType,
  packSchedule,
  expectedType,
  completedAt = new Date().toISOString(),
}) {
  const pack = PACK_DEFINITIONS[packType];
  const access = getPackAccess(packType);
  const schedule = Array.isArray(packSchedule) ? [...packSchedule] : [];
  if (!pack || !access.hasScheduledSteps || typeof expectedType !== 'string') {
    return { changed: false, schedule, stepNumber: null };
  }

  const currentIndex = pack.steps.findIndex((_, index) => {
    const stored = schedule.find((step) => step?.stepNumber === index + 1);
    return stored?.status !== 'done';
  });
  if (currentIndex < 0 || pack.steps[currentIndex]?.type !== expectedType) {
    return { changed: false, schedule, stepNumber: null };
  }

  const stepNumber = currentIndex + 1;
  const existingIndex = schedule.findIndex((step) => step?.stepNumber === stepNumber);
  const completed = {
    ...(existingIndex >= 0 ? schedule[existingIndex] : {}),
    stepNumber,
    status: 'done',
    completedAt,
  };
  if (existingIndex >= 0) schedule[existingIndex] = completed;
  else schedule.push(completed);

  return { changed: true, schedule, stepNumber };
}

/**
 * Compte les consultations effectuées SUR LA PÉRIODE COURANTE du pack.
 * Le journal reste append-only ; seules les entrées de la période active
 * consomment le quota. Une entrée legacy sans date compte par sécurité.
 */
function consultationsInPeriod(consultationsLog, packStartedAt) {
  const log = Array.isArray(consultationsLog) ? consultationsLog : [];
  if (!packStartedAt) return log;
  const startMs = new Date(packStartedAt).getTime();
  if (Number.isNaN(startMs)) return log;
  return log.filter((c) => {
    const t = new Date(c?.date).getTime();
    // Entrée sans date valide = héritée/legacy → on la compte (fail-safe :
    // ne jamais sous-estimer le quota consommé).
    if (Number.isNaN(t)) return true;
    return t >= startMs;
  });
}

export function countConsultationsInPeriod(consultationsLog, packStartedAt) {
  return consultationsInPeriod(consultationsLog, packStartedAt).length;
}

/**
 * Compteur visible des rendez-vous du pack. Le rendez-vous initial fait partie
 * du contrat ; consultations_log reste reserve aux rendez-vous de suivi afin
 * de conserver les quotas et les preuves serveur existants.
 */
export function getPackAppointmentProgress(client, consultationsLog) {
  const access = getPackAccess(client?.packType || client?.pack_type);
  const initialCompleted = access.initialAnamnesisConsultations > 0
    && client?.packStartedAtConfirmed === true
    && Number.isFinite(Date.parse(client?.packStartedAt || ''))
    ? access.initialAnamnesisConsultations
    : 0;
  const followupsCompleted = countConsultationsInPeriod(
    consultationsLog,
    client?.packStartedAt,
  );
  return {
    total: access.totalAppointments,
    completed: Math.min(
      access.totalAppointments,
      initialCompleted + followupsCompleted,
    ),
    initialCompleted,
    followupsCompleted,
    followupsTotal: access.includedFollowupConsultations,
  };
}

export function getInitialAppointmentDate(client) {
  const journey = client?.journeyState || client?.journey_state || {};
  return [
    journey.rdv_anamnesis_at,
    journey.anamnesis_completed_at,
    client?.packStartedAt,
  ].find((value) => Number.isFinite(Date.parse(value || ''))) || null;
}

/**
 * Calcule le taux de complétion du pack (KPI).
 */
export function getPackCompletion(client) {
  const steps = buildPackFollowupSchedule(client);
  if (steps.length === 0) return null;
  const done = steps.filter(s => s.status === 'done').length;
  return { done, total: steps.length, percent: Math.round((done / steps.length) * 100) };
}
